import { Form, Row, Col } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { FileUpload, Input, PageWrapper, Select } from "../../components";
import { useTranslation } from "react-i18next";
import { Pages } from '../../shared/enums'
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { createBanner, getBannerDetail, updateBanner } from "../../api/banner";
import { RiEdit2Fill, RiAddLargeLine } from "react-icons/ri";
import Button from '../../components/common/Button';

const BannerDetail = ({ }) => {
    const { t } = useTranslation()
    const form = useForm({
        defaultValues: {
            isPublish: true
        }
    })
    const navigate = useNavigate()
    const { id } = useParams()
    const [isEdit, setIsEdit] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)

    useEffect(() => {
        if (id !== "new") {
            setIsEdit(true)
            getData()
        }
    }, [])

    const getData = async () => {
        const response = await getBannerDetail(id)
        const imageData = response.attachmentId || response.image
        form.reset({
            ...response,
            image: imageData
        })
    }

    const create = async (data) => {
        setBtnLoading(true)
        const response = await createBanner(data)
        if (response.success) navigate(Pages.Banner)
        setBtnLoading(false)
    }

    const update = async (data) => {
        setBtnLoading(true)
        const response = await updateBanner(id, data)
        if (response.success) navigate(Pages.Banner)
        setBtnLoading(false)
    }

    return <PageWrapper
        headerProps={{
            title: isEdit ? "EDIT_BANNER" : "ADD_BANNER",
            rightElement: <Button
                type="submit"
                variant="primary"
                icon={isEdit ? <RiEdit2Fill /> : <RiAddLargeLine />}
                loading={btnLoading}
                onClick={() => form.handleSubmit(isEdit ? update : create)()}
            >
                {t(isEdit ? "UPDATE" : "CREATE")}
            </Button>
        }}
    >
        <FormProvider {...form}>
            <Form>

                <Input label={t("TITLE")} name={"title"} rules={{ required: t("TITLE_IS_REQUIRED") }} />
                <Input label={t("DESCRIPTION")} rows={3} name={"description"} rules={{ required: t("DESCRIPTION_IS_REQUIRED") }} />
                <Row>
                    <Col>
                        <Select label={t("IS_PUBLISH")} name={"isPublish"} rules={{ required: t("IS_PUBLISH_IS_REQUIRED") }} options={[{ label: t("YES"), value: true }, { label: t("NO"), value: false }]} />
                    </Col>
                    <Col>
                        <Input label={t("SEQUENCE")} type={"number"} name={"sequence"} rules={{ required: t("SEQUENCE_IS_REQUIRED") }} />
                    </Col>
                </Row>
                <FileUpload
                    fileName={form.getValues('attachmentId')?.originalName || form.getValues('fileName')}
                    label={t("IMAGE")}
                    name="image"
                    rules={{ required: t("IMAGE_IS_REQUIRED") }}
                    readOnly={isEdit}
                    accept="image/*"
                />
            </Form>
        </FormProvider>
    </PageWrapper>
}

export default BannerDetail;